module.exports = __webpack_public_path__ + "static/media/meme-2.3b9b9e18.webp";